import { VBadge } from '@vrzl/ui';
import { useSetAtom } from 'jotai';

import { documentDialogAtom } from '@/domains/documents';

import type { Source } from '../api/types';
import { buildSourceLinks } from '../utils/sourceLinks';

type ChatSourcesProps = {
  sources: Source[];
  documents: { id: string; name: string; sourceFileName: string | null }[];
  eventId: string;
};

export function ChatSources({ sources, documents, eventId }: ChatSourcesProps) {
  const setDocDialog = useSetAtom(documentDialogAtom);

  if (sources.length === 0) return null;

  const links = buildSourceLinks(sources, documents);

  return (
    <div className="mt-2 flex flex-wrap gap-1.5">
      {links.map((link, index) => {
        const { label, docId, page } = link;

        if (!docId) {
          return (
            <VBadge key={index} color="neutral">
              {label}
            </VBadge>
          );
        }

        return (
          <button
            key={index}
            type="button"
            onClick={() =>
              setDocDialog({
                eventId,
                docId,
                initialPages: page != null ? [page] : undefined,
              })
            }
          >
            <VBadge color="info" className="hover:underline">
              {label}
            </VBadge>
          </button>
        );
      })}
    </div>
  );
}
